import { ReactNode } from 'react';
import { Button, Dialog, FormHelperText, Loader, Typography } from '@screentone/core';

type ConfirmationDialogProps = {
  title: string;
  isLoading: boolean;
  description: ReactNode;
  hint?: string | JSX.Element;
  disabled?: boolean;
  onClickFunc: () => void;
  showDialog: (show: boolean) => void;
  confirmLabel?: string;
};

export const ConfirmationDialog = ({
  title,
  isLoading,
  showDialog,
  onClickFunc,
  description,
  hint,
  disabled,
  confirmLabel = 'Confirm'
}: ConfirmationDialogProps) => (
  <Dialog
    status="open"
    aria-labelledby="dialogTitle"
    aria-describedby="dialogDesc"
    onDismiss={() => !isLoading && showDialog(false)}
    renderNode={document.body}
  >
    <Dialog.Title id="dialogTitle">{title}</Dialog.Title>
    <Dialog.Content id="dialogDesc" data-testid="confirmation-msg">
      <Typography size="md" weight="reg">
        {description}
      </Typography>
      {hint && (
        <>
          <br />
          <FormHelperText>{hint}</FormHelperText>
        </>
      )}
    </Dialog.Content>
    <Dialog.Actions>
      <Button secondary onClick={() => showDialog(false)} disabled={isLoading}>
        Cancel
      </Button>
      <Button primary onClick={onClickFunc} disabled={isLoading || disabled} data-testid="confirm-button">
        {isLoading ? <Loader size="md" /> : confirmLabel}
      </Button>
    </Dialog.Actions>
  </Dialog>
);
